<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Loan Shops'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Loan Shops',

            actions: [
                {
                    icon: 'fab fa-product-hunt',
                    method: 'goToProducts'
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '180px' },
                {
                    width: '200px',
                    text: 'Campus',
                    sortable: false,
                    value: 'campuses',
                    filterFieldName: 'campuses.name',
                    filter: 'joinTable'
                },
                {
                    value: 'slug',
                    width: '180px'
                },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'loanShops/index',
            deleteItem: 'loanShops/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/loan-shops/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/loan-shops/add');
        },
        goToProducts(id) {
            this.$router.push(`/loan-shops/${id}/loan-products`);
        }
    }
};
</script>
